import Base from './action-base'
import renderFields from './fake-call.pug'

export default class FakeCall extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-phone"

  @DEFAULTS:
    callerName: "未知"
    callerNumber: "0000"
    instanceId: null
    ring: # drop instanceId temp
      assetId: null
      pause: false,
      currentTime: 0
      fadeInSeconds: 0
      fadeOutSeconds: 0
      volume: 1.0
      repeat: 1
    call: # also instanceId
      assetId: null
      pause: false,
      currentTime: 0
      fadeInSeconds: 0
      fadeOutSeconds: 0
      volume: 1.0
      repeat: 1

  renderFields: renderFields
